import * as React from 'react'

import { useRecoilValue } from 'recoil'

import { Ids } from '../../../constants/Ids'
import { translate } from '../../../state/locale/selectors/translate'
import { ParagraphText } from '../../reusable/ParagraphText'
import styles from './Jobs.module.scss'
import { IJobsProps } from './Jobs.types'

export const Jobs = ({ data }: IJobsProps) => {
  const i18n = useRecoilValue(translate).jobs

  return (
    <div className={styles.jobsWrapper}>
      <h2 className={styles.pageTitle} id={Ids.rentLocations}>
        {data.title}
      </h2>
      <ParagraphText text={data.description} />
      {!!data.jobOffers.length && (
        <>
          <h3 className={styles.offersTitle}>{i18n.offers}</h3>
          {data.jobOffers.map((offer) => (
            <div className={styles.offer} key={String(offer.title)}>
              <h5 className={styles.title}>{offer.title}</h5>
              <h5 className={styles.department}>{offer.department}</h5>
              <ParagraphText text={offer.description} />
              <ParagraphText text={offer.additionalInfo} />
            </div>
          ))}
        </>
      )}
    </div>
  )
}
